<h2 mat-dialog-title style="text-align: center;">Declaração de TAC</h2>

<mat-dialog-content>
  <div class="declaracao-dialog-grid">
    <p><strong>Data da consulta:</strong> {{ dataConsultaFormatada }}</p>
    <p><strong>Consultado:</strong> {{ consultadoLabel }}</p>
    <p><strong>Situação da Declaração:</strong> {{ situacaoLabel }}</p>
  </div>

  <div *ngIf="data.situacao === 'possui_pendencias' && data.mensagemPendencias" class="mensagem-pendencias">
    <p class="mensagem-pendencias-titulo">ATENÇÃO</p>
    <p class="mensagem-pendencias-texto">{{ data.mensagemPendencias }}</p>
  </div>

  <ng-container *ngIf="showProcessTable">
    <h4 class="admin-section-title">
      TACs encontrados
      <span *ngIf="showSelecaoTacs" class="processos-hint">(selecione os que devem constar na declaração)</span>
    </h4>

    <div class="tabela-processos">
      <table>
        <thead>
          <tr>
            <th *ngIf="showSelecaoTacs" class="col-check">
              <mat-checkbox [checked]="todosSelecionados" [indeterminate]="algumSelecionado && !todosSelecionados"
                (change)="toggleTodos()" title="Selecionar todos"></mat-checkbox>
            </th>
            <th>Processo SEI</th>
            <th>Situação</th>
            <th>Data da celebração</th>
            <th>Data de vigência</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let p of tacsUnificados" [class.row-selecionada]="showSelecaoTacs && tacsSelecionados.has(p.numero)">
            <td *ngIf="showSelecaoTacs" class="col-check">
              <mat-checkbox [checked]="tacsSelecionados.has(p.numero)"
                (change)="toggleTac(p.numero)"></mat-checkbox>
            </td>
            <td>{{ p.numero }}</td>
            <td>{{ p.status }}</td>
            <td>{{ p.dataCelebracao }}</td>
            <td>{{ p.dataVigencia }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p *ngIf="showSelecaoTacs && !algumSelecionado" class="aviso-selecao">
      Selecione ao menos um TAC para emitir a declaração positiva.
    </p>
  </ng-container>

  <ng-container *ngIf="showAdminExtras">
    <mat-form-field appearance="outline" class="observacoes-field">
      <mat-label>Observações da declaração</mat-label>
      <textarea matInput [(ngModel)]="observacoes" rows="3"
        placeholder="Observações que constarão do corpo da declaração positiva"></textarea>
    </mat-form-field>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="sair()">Sair</button>
  <button *ngIf="emissaoCompleta && data.situacao === 'possui_pendencias'" mat-stroked-button color="warn"
    (click)="emitirNadaConsta()">
    Emitir Nada Consta
  </button>
  <button *ngIf="podeMostrarBotaoEmitir" mat-raised-button color="primary" (click)="emitirESair()">
    Emitir
  </button>
</mat-dialog-actions>
